import openingDatabase from '../../data/openings.json';

export const OPENING_DATABASE_INFO = {
  source: openingDatabase.source,
  revision: openingDatabase.revision,
  license: openingDatabase.license,
  count: openingDatabase.count,
};

export const classifyOpening = (moveHistory = []) => {
  for (let index = moveHistory.length - 1; index >= 0; index -= 1) {
    const epd = moveHistory[index]?.epd;
    const match = epd ? openingDatabase.positions[epd] : null;
    if (!match) continue;

    const [eco, name] = match;
    const separator = name.indexOf(':');
    return {
      eco,
      name,
      family: separator >= 0 ? name.slice(0, separator) : name,
      variation: separator >= 0 ? name.slice(separator + 1).trim() : null,
      matchedPly: index + 1,
      currentPly: moveHistory.length,
    };
  }
  return null;
};
